// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-row[data-v-392c221e]{display:flex;gap:10px}.input-row-radio-group[data-v-392c221e]{margin-top:3px}.input-row[data-v-392c221e] .v-input--radio-group.v-input--radio-group--row .v-radio:last-child{margin-right:0}.input-row-span[data-v-392c221e]{font-size:16px;display:inline-block;margin-top:7px}.input-row-button[data-v-392c221e]{margin-top:2px}.flexible-width[data-v-392c221e]{flex:1 1 100%}.fixed-width[data-v-392c221e]{flex:0 0 auto}", ""]);
// Exports
module.exports = exports;
